// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width: 769px){
    .jw-button {
        font-size: 28px;
        font-weight: 500;
        line-height: 46px;
        text-align: left;
        border: 3px;
        padding: 8px 30px;
        background: #00EFC1;
        border: 3px solid#000000;
        box-shadow: 7px 7px 0px 0px #000000;
        border-radius: 100px;
    }
    .jw-button2 {
        font-family: Bebas Neue;
        font-size: 50px;
        font-weight: 400;
        line-height: 53px;
        text-align: left;
        border: 3px;
        padding: 8px 27px;
        transform: rotate(3.18deg);
        background: linear-gradient(0deg, #00EFC1, #00EFC1), linear-gradient(0deg, #000000, #000000);
        border: 3px solid#000000;
        box-shadow: 3px 3px 0px 0px #000000;
        letter-spacing: 3px;
    }

    
    .header-center {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .hpage-center {
        margin: 4% 7%;
    }
    .footer-jwb {
        transform: translateX(-30%);
    }
    .x-footer {
        border-top: 1.5px solid rgba(0, 239, 193, 0.2);
    }
}
@media screen and (min-width: 1024px) {
    .e-page {
        min-height: calc(100vh - 0px);
    }
}
@media screen and (max-width: 768px){
    .jw-button {
        font-family: Bebas Neue;
        font-size: 25px;
        font-weight: 400;
        line-height: 53px;
        border: 1.85px solid #000000;
        padding: 1px 10px;
        background: #00EFC1;
        
        box-shadow: 4.32px 4.32px 0px 0px #000000;
        border-radius: 100px;
        letter-spacing: 3px;
    }
    .jw-button2 {
        font-family: Bebas Neue;
        font-size: 30px;
        font-weight: 400;
        line-height: 53px;
        text-align: left;
        border: 3px;
        padding: 8px 20px;
        transform: rotate(3.18deg);
        background: linear-gradient(0deg, #00EFC1, #00EFC1), linear-gradient(0deg, #000000, #000000);
        border: 3px solid#000000;
        box-shadow: 3px 3px 0px 0px #000000;
        letter-spacing: 3px;
    }
}

.spinner {
    width: 20px;
    padding: 2px;
    aspect-ratio: 1;
    border-radius: 50%;
    background: #000000;
    --_m: 
      conic-gradient(#0000 10%,#000),
      linear-gradient(#000 0 0) content-box;
    mask: var(--_m);
    mask-composite: subtract;
    animation: l3 1s infinite linear;
  }
  @keyframes l3 {to{transform: rotate(1turn)}}`, "",{"version":3,"sources":["webpack://./src/assets/waitlist.css"],"names":[],"mappings":"AAAA;IACI;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,iBAAiB;QACjB,mBAAmB;QACnB,wBAAwB;QACxB,mCAAmC;QACnC,oBAAoB;IACxB;IACA;QACI,uBAAuB;QACvB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,iBAAiB;QACjB,0BAA0B;QAC1B,4FAA4F;QAC5F,wBAAwB;QACxB,mCAAmC;QACnC,mBAAmB;IACvB;;;IAGA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gCAAgC;IACpC;IACA;QACI,aAAa;IACjB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,8CAA8C;IAClD;AACJ;AACA;IACI;QACI,6BAA6B;IACjC;AACJ;AACA;IACI;QACI,uBAAuB;QACvB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,4BAA4B;QAC5B,iBAAiB;QACjB,mBAAmB;;QAEnB,yCAAyC;QACzC,oBAAoB;QACpB,mBAAmB;IACvB;IACA;QACI,uBAAuB;QACvB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,iBAAiB;QACjB,0BAA0B;QAC1B,4FAA4F;QAC5F,wBAAwB;QACxB,mCAAmC;QACnC,mBAAmB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB;;2CAEuC;IAE/B,eAAe;IAEf,wBAAwB;IAChC,gCAAgC;EAClC;EACA,eAAe,GAAG,wBAAwB,CAAC","sourcesContent":["@media screen and (min-width: 769px){\n    .jw-button {\n        font-size: 28px;\n        font-weight: 500;\n        line-height: 46px;\n        text-align: left;\n        border: 3px;\n        padding: 8px 30px;\n        background: #00EFC1;\n        border: 3px solid#000000;\n        box-shadow: 7px 7px 0px 0px #000000;\n        border-radius: 100px;\n    }\n    .jw-button2 {\n        font-family: Bebas Neue;\n        font-size: 50px;\n        font-weight: 400;\n        line-height: 53px;\n        text-align: left;\n        border: 3px;\n        padding: 8px 27px;\n        transform: rotate(3.18deg);\n        background: linear-gradient(0deg, #00EFC1, #00EFC1), linear-gradient(0deg, #000000, #000000);\n        border: 3px solid#000000;\n        box-shadow: 3px 3px 0px 0px #000000;\n        letter-spacing: 3px;\n    }\n\n    \n    .header-center {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n    }\n    .hpage-center {\n        margin: 4% 7%;\n    }\n    .footer-jwb {\n        transform: translateX(-30%);\n    }\n    .x-footer {\n        border-top: 1.5px solid rgba(0, 239, 193, 0.2);\n    }\n}\n@media screen and (min-width: 1024px) {\n    .e-page {\n        min-height: calc(100vh - 0px);\n    }\n}\n@media screen and (max-width: 768px){\n    .jw-button {\n        font-family: Bebas Neue;\n        font-size: 25px;\n        font-weight: 400;\n        line-height: 53px;\n        border: 1.85px solid #000000;\n        padding: 1px 10px;\n        background: #00EFC1;\n        \n        box-shadow: 4.32px 4.32px 0px 0px #000000;\n        border-radius: 100px;\n        letter-spacing: 3px;\n    }\n    .jw-button2 {\n        font-family: Bebas Neue;\n        font-size: 30px;\n        font-weight: 400;\n        line-height: 53px;\n        text-align: left;\n        border: 3px;\n        padding: 8px 20px;\n        transform: rotate(3.18deg);\n        background: linear-gradient(0deg, #00EFC1, #00EFC1), linear-gradient(0deg, #000000, #000000);\n        border: 3px solid#000000;\n        box-shadow: 3px 3px 0px 0px #000000;\n        letter-spacing: 3px;\n    }\n}\n\n.spinner {\n    width: 20px;\n    padding: 2px;\n    aspect-ratio: 1;\n    border-radius: 50%;\n    background: #000000;\n    --_m: \n      conic-gradient(#0000 10%,#000),\n      linear-gradient(#000 0 0) content-box;\n    -webkit-mask: var(--_m);\n            mask: var(--_m);\n    -webkit-mask-composite: source-out;\n            mask-composite: subtract;\n    animation: l3 1s infinite linear;\n  }\n  @keyframes l3 {to{transform: rotate(1turn)}}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
